import { FC } from 'react';
import { useSelector } from 'react-redux';

import Typography from '@/components/typography';
import { getAcresOfSelectionsPanelFeatures } from '@/features/selectionsPanel/util/determineSelectionsPanelAcres';
import { RootState } from '@/redux/store';

type Props = {
  formattedTotalAcres: string;
};

export const Header: FC<Props> = ({ formattedTotalAcres }) => {
  const { allFeatures } = useSelector((state: RootState) => state.features);
  const totalAcres = getAcresOfSelectionsPanelFeatures(allFeatures);

  if (totalAcres === 0) return null;

  return (
    <div className="sticky top-0 z-30 border-b bg-gray-10 p-2 px-4">
      <div className="flex flex-col gap-2">
        <div className="flex">
          <Typography variant="h3">{formattedTotalAcres}</Typography>
          <Typography className="ml-2 leading-[28px]" variant="h5">
            acres
          </Typography>
        </div>
      </div>
    </div>
  );
};
